import { useState } from "react";
import Input from "../../../components/Input";
import InputSelect from "../../../components/Input-select";
import { toastError } from "../../../components/Toast";
import { orderByName } from "../../../libs/orderList";
import useHistoryStore from "../store/useStore";

export function FilterRow() {
  const { listUsersFilter, filterCollaborator, filterProject, listProject } = useHistoryStore();
  const { setFilterCollaborator, setFilterProject, setNeedSpinner, getHistory } = useHistoryStore();

  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");

  const listCollaboratorOrder = orderByName(listUsersFilter, "name");

  function handleFilterClick() {
    setNeedSpinner(true);
    const queryString = coditionQueryString();
    if (queryString === true) return;
    getHistory(queryString);
  }

  function handleClearFilterClick() {
    setNeedSpinner(true);
    setFilterCollaborator(0);
    setFilterProject(0);
    setDateFrom("");
    setDateTo("");
    getHistory();
  }

  function coditionQueryString() {
    let queryString = "?";
    if (filterCollaborator) queryString += "userId=" + filterCollaborator;
    if (dateFrom && dateTo) {
      queryString += "&dateFrom=" + dateFrom;
      queryString += "&dateTo=" + dateTo;
    }
    if (filterProject) {
      queryString += "&projectId=" + filterProject;
    }
    if (dateFrom && !dateTo) {
      setNeedSpinner(false);
      toastError("Selecione uma data final");
      return true;
    }
    if (!dateFrom && dateTo) {
      setNeedSpinner(false);
      toastError("Selecione uma data inicial");
      return true;
    }
    if (filterProject && !dateFrom && !dateTo) {
      setNeedSpinner(false);
      toastError("Para filtrar um projeto, é obrigatório data inicial e final");
      return true;
    }
    return queryString;
  }

  return (
    <>
      <div className="filterContainer nowrap-filter-row">
        <div className="rowFilterContainer">
          <InputSelect
            className="inputContainer field-history"
            name="search"
            label="Profissional"
            placeholder="Pesquisar"
            onChange={(event: any) => {
              setFilterCollaborator(event.target.value);
            }}
            value={filterCollaborator}
            list={listCollaboratorOrder}
          />
          <InputSelect
            className="inputContainer field-history"
            name="search"
            label="Projeto"
            placeholder="Pesquisar"
            onChange={(event: any) => {
              setFilterProject(event.target.value);
            }}
            value={filterProject}
            list={listProject}
          />
          <Input
            setValue={(event: any) => setDateFrom(event.target.value)}
            value={dateFrom}
            name="date"
            label="Data inicial"
            className="inputContainer teste45 field-history"
            type="date"
            placeholder="Digite o período inicial"
          />
          <Input
            setValue={(event: any) => setDateTo(event.target.value)}
            value={dateTo}
            name="date"
            label="Data final"
            className="inputContainer teste45 field-history"
            type="date"
            placeholder="Digite o período"
          />
        </div>
      </div>
      <div className="flex btnContainer div-history-filter-btn">
        <button className="btn filter-btn history-filter-btn" onClick={handleFilterClick}>
          Filtrar
        </button>
        <button className="Link btn bg-secondary history-filter-btn" onClick={handleClearFilterClick}>
          Limpar
        </button>
      </div>
    </>
  );
}
